import React from "react";
import { useNavigate, useParams } from "react-router-dom";

import {
  fetchFirmPdf,
  useFirmDeclineMutation,
  useFirmSignMutation,
  useGetFirmSigningViewQuery,
} from "../../../slices/SignaturesSlice";
import { errorText } from "../../clientPortal/PortalModal";
import { SigningNotice, SigningView } from "../components/SigningView";

/** A firm user countersigns (signed in to ProCharted as usual). */
export const FirmSignPage = () => {
  const { id = "" } = useParams();
  const navigate = useNavigate();
  const view = useGetFirmSigningViewQuery(id, {
    skip: !id,
    refetchOnMountOrArgChange: true,
  });
  const [sign] = useFirmSignMutation();
  const [decline] = useFirmDeclineMutation();

  const back = (
    <button
      type={"button"}
      className={"mt-2 text-sm font-bold text-[#6B4EFF]"}
      onClick={() => navigate(-1)}>
      Back
    </button>
  );

  return (
    <div
      className={
        "flex min-h-full flex-col bg-[#F1F2F5] font-Manrope text-[#1F2433]"
      }>
      {view.isLoading ? (
        <div
          className={"py-20 text-center text-sm font-semibold text-[#6B7185]"}>
          Opening the document…
        </div>
      ) : !view.data ? (
        <div>
          <SigningNotice
            title={"This document can’t be opened"}
            text={errorText(view.error)}>
            {back}
          </SigningNotice>
        </div>
      ) : (
        <SigningView
          view={view.data}
          identityNote={"Signed in to ProCharted"}
          defaultName={view.data.signers.find((s) => s.isMe)?.name ?? ""}
          loadPdf={() => fetchFirmPdf(`api/signatures/${id}/sign/document`)}
          onSign={async (body) => {
            const result = await sign({ id, body });
            if ("error" in result) return errorText(result.error);
            view.refetch();
            return null;
          }}
          onDecline={async (reason) => {
            const result = await decline({ id, reason });
            return "error" in result ? errorText(result.error) : null;
          }}
          doneActions={back}
        />
      )}
    </div>
  );
};
